module.exports = __webpack_public_path__ + "static/media/Hospitality_56.e3c0cb2b.jpg";